import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ApolloResponse1aeginapbuksm as ApolloResponse } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  cancel36mj9lv3a0whl as cancel,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Builder4ra56zvvku0a as Builder } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ExecutionContext.mjs';
import { plus310ted5e4i90h as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { withContextp2qc4rbktyej as withContext } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ProducerScopeb3mmhvfa6ll7 as ProducerScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Produce.mjs';
import { Builder3d75eph7uovs3 as Builder_0 } from './network/http/HttpNetworkTransport.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Builder1suvx83rlbrz1 as Builder_1 } from './network/websocket/WebSocketNetworkTransport.mjs';
import {
  Companion_getInstancevdtg3uvqmv7f as Companion_getInstance_0,
  toDurationba1nlt78o6vu as toDuration,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancen5e0rps4ljgd as DurationUnit_MILLISECONDS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Builder3moivcm5iuump as Builder_2 } from './network/ws/WebSocketNetworkTransport.mjs';
import { get_defaultDispatcher3rblue9uzsji2 as get_defaultDispatcher } from './internal/dispatchers.js.mjs';
import { ConcurrencyInfo3mmnli95yq2g0 as ConcurrencyInfo } from './ConcurrencyInfo.mjs';
import { NetworkInterceptor22fszyorwx7pt as NetworkInterceptor } from './interceptor/NetworkInterceptor.mjs';
import { ApolloCallpwdxdy18rzuy as ApolloCall } from './ApolloCall.mjs';
import { channelFlow1or0c85tk04v1 as channelFlow } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { buffer2o7vhreze5nfc as buffer } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { RetryOnErrorInterceptor2wqvvqzzzk2ot as RetryOnErrorInterceptor } from './interceptor/RetryOnErrorInterceptor.mjs';
import { DefaultInterceptorChain10weji0clzo5q as DefaultInterceptorChain } from './interceptor/ApolloInterceptor.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_channelFlow) {
        this.k67_1 = $this_channelFlow;
      }
      *l67(it, $completion) {
        yield* this.k67_1.g1b(it, $completion);
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.l67(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0($this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda$slambda())($this_channelFlow);
  var l = (it, $completion) => i.l67(it, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing, $this_channelFlow) {
        this.m67_1 = this$0;
        this.n67_1 = $apolloRequest;
        this.o67_1 = $throwing;
        this.p67_1 = $this_channelFlow;
      }
      *k1g($this$withContext, $completion) {
        var tmp = this.m67_1.q67(this.n67_1, this.o67_1);
        var tmp_0 = ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0(this.p67_1);
        yield* tmp.d1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp_0), $completion);
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.k1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda_0(this$0, $apolloRequest, $throwing, $this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda())(this$0, $apolloRequest, $throwing, $this_channelFlow);
  var l = ($this$withContext, $completion) => i.k1g($this$withContext, $completion);
  l.$arity = 1;
  return l;
}
var BuilderClass;
function Builder_3() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.r67_1 = new (Builder())();
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.s67_1 = ArrayList().p2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.t67_1 = ArrayList().p2();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.u67_1 = ArrayList().p2();
        var tmp_2 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_2.v67_1 = ArrayList().p2();
        var tmp_3 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_3.w67_1 = ArrayList().p2();
        this.x67_1 = this.w67_1;
        this.y67_1 = Companion_getInstance().a44_1;
        this.z67_1 = null;
        this.a68_1 = null;
        this.b68_1 = null;
        this.c68_1 = null;
        this.d68_1 = null;
        this.e68_1 = null;
        this.f68_1 = null;
        this.g68_1 = null;
        this.h68_1 = null;
        this.i68_1 = null;
        this.j68_1 = null;
        this.k68_1 = null;
        this.l68_1 = null;
        this.m68_1 = null;
        this.n68_1 = null;
        this.o68_1 = null;
        this.p68_1 = null;
        this.q68_1 = null;
        this.r68_1 = null;
        this.s68_1 = null;
        this.t68_1 = null;
        this.u68_1 = null;
        this.v68_1 = null;
        this.w68_1 = null;
        this.x68_1 = null;
        this.y68_1 = true;
      }
      z68() {
        return this.r67_1.l38();
      }
      a69() {
        return plus(plus(plus(this.s67_1, this.t67_1), this.u67_1), this.v67_1);
      }
      p44(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.y68_1 = sendEnhancedClientAwareness;
        return this;
      }
      o44(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.v68_1 = failFastIfOffline;
        return this;
      }
      b69(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.t68_1 = retryOnError;
        return this;
      }
      c69(retryOnErrorInterceptor) {
        // Inline function 'kotlin.apply' call
        this.u68_1 = retryOnErrorInterceptor;
        return this;
      }
      d69(cacheInterceptor) {
        // Inline function 'kotlin.apply' call
        this.w68_1 = cacheInterceptor;
        return this;
      }
      e69(autoPersistedQueryInterceptor) {
        // Inline function 'kotlin.apply' call
        this.x68_1 = autoPersistedQueryInterceptor;
        return this;
      }
      e44(url) {
        // Inline function 'kotlin.apply' call
        this.z67_1 = url;
        return this;
      }
      f44(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.a68_1 = httpMethod;
        return this;
      }
      g44(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.b68_1 = httpHeaders;
        return this;
      }
      i44(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.c68_1 = sendApqExtensions;
        return this;
      }
      j44(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.d68_1 = sendDocument;
        return this;
      }
      k44(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.e68_1 = enableAutoPersistedQueries;
        return this;
      }
      l44(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.f68_1 = canBeBatched;
        return this;
      }
      m44(ignoreUnknownKeys) {
        // Inline function 'kotlin.apply' call
        this.g68_1 = ignoreUnknownKeys;
        return this;
      }
      f69(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.k68_1 = serverUrl;
        return this;
      }
      g69(httpServerUrl) {
        // Inline function 'kotlin.apply' call
        this.k68_1 = httpServerUrl;
        return this;
      }
      h69(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.l68_1 = httpEngine;
        return this;
      }
      i69(httpExposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.p68_1 = httpExposeErrorBody;
        return this;
      }
      j69(httpInterceptors) {
        // Inline function 'kotlin.apply' call
        this.w67_1.a5();
        this.w67_1.u2(httpInterceptors);
        return this;
      }
      k69(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.m68_1 = webSocketServerUrl;
        return this;
      }
      l69(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.s68_1 = webSocketServerUrl;
        return this;
      }
      m69(webSocketIdleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.n68_1 = webSocketIdleTimeoutMillis;
        return this;
      }
      n69(wsProtocolFactory) {
        // Inline function 'kotlin.apply' call
        this.o68_1 = wsProtocolFactory;
        return this;
      }
      o69(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.q68_1 = webSocketEngine;
        return this;
      }
      p69(webSocketReopenWhen) {
        // Inline function 'kotlin.apply' call
        this.r68_1 = webSocketReopenWhen;
        return this;
      }
      q69(networkTransport) {
        // Inline function 'kotlin.apply' call
        this.h68_1 = networkTransport;
        return this;
      }
      r69(subscriptionNetworkTransport) {
        // Inline function 'kotlin.apply' call
        this.i68_1 = subscriptionNetworkTransport;
        return this;
      }
      s69(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.r67_1.a5();
        this.r67_1.k49(customScalarAdapters);
        return this;
      }
      t69(dispatcher) {
        // Inline function 'kotlin.apply' call
        this.j68_1 = dispatcher;
        return this;
      }
      c44(executionContext) {
        // Inline function 'kotlin.apply' call
        this.y67_1 = executionContext;
        return this;
      }
      l38() {
        return new (ApolloClient())(this.g39());
      }
      g39() {
        // Inline function 'kotlin.also' call
        var this_0 = (new (Builder_3())()).s69(this.r67_1.l38());
        this_0.s67_1.u2(this.s67_1);
        this_0.t67_1.u2(this.t67_1);
        this_0.u67_1.u2(this.u67_1);
        this_0.v67_1.u2(this.v67_1);
        return this_0.t69(this.j68_1).c44(this.y67_1).e44(this.z67_1).f44(this.a68_1).g44(this.b68_1).g69(this.k68_1).h69(this.l68_1).i69(this.p68_1).j69(this.x67_1).i44(this.c68_1).j44(this.d68_1).k44(this.e68_1).l44(this.f68_1).m44(this.g68_1).q69(this.h68_1).r69(this.i68_1).k69(this.m68_1).l69(this.s68_1).o69(this.q68_1).p69(this.r68_1).m69(this.n68_1).n69(this.o68_1).b69(this.t68_1).c69(this.u68_1).d69(this.w68_1).e69(this.x68_1).o44(this.v68_1).p44(this.y68_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_3);
    BuilderClass = $;
  }
  return BuilderClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.u69_1 = function_0;
      }
      *a1e(value, $completion) {
        return yield* this.u69_1(value, $completion);
      }
      i5() {
        return this.u69_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var ApolloClient$executeAsFlowInternal$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing) {
        this.v69_1 = this$0;
        this.w69_1 = $apolloRequest;
        this.x69_1 = $throwing;
      }
      *y69($this$channelFlow, $completion) {
        yield* withContext(this.v69_1.n66_1.z69_1, ApolloClient$executeAsFlowInternal$slambda$slambda_0(this.v69_1, this.w69_1, this.x69_1, $this$channelFlow), $completion);
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.y69((!(p1 == null) ? isInterface(p1, ProducerScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda_0(this$0, $apolloRequest, $throwing) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda())(this$0, $apolloRequest, $throwing);
  var l = ($this$channelFlow, $completion) => i.y69($this$channelFlow, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClient$apolloResponses$slambdaClass;
function ApolloClient$apolloResponses$slambda() {
  if (ApolloClient$apolloResponses$slambdaClass === VOID) {
    class $ {
      *l67(response, $completion) {
        if (!(response.d46_1 == null)) {
          throw ensureNotNull(response.d46_1);
        }
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.l67(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$apolloResponses$slambdaClass = $;
  }
  return ApolloClient$apolloResponses$slambdaClass;
}
function ApolloClient$apolloResponses$slambda_0() {
  var i = new (ApolloClient$apolloResponses$slambda())();
  var l = (response, $completion) => i.l67(response, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClientClass;
function ApolloClient() {
  if (ApolloClientClass === VOID) {
    class $ {
      constructor(builder) {
        this.m66_1 = builder;
        this.q66_1 = this.m66_1.a69();
        this.r66_1 = this.m66_1.z68();
        this.s66_1 = this.m66_1.w68_1;
        this.t66_1 = this.m66_1.x68_1;
        this.u66_1 = this.m66_1.t68_1;
        this.v66_1 = this.m66_1.u68_1;
        this.w66_1 = this.m66_1.v68_1;
        this.x66_1 = this.m66_1.y68_1;
        this.y66_1 = this.m66_1.y67_1;
        this.z66_1 = this.m66_1.z67_1;
        this.a67_1 = this.m66_1.a68_1;
        this.b67_1 = this.m66_1.b68_1;
        this.c67_1 = this.m66_1.c68_1;
        this.d67_1 = this.m66_1.d68_1;
        this.e67_1 = this.m66_1.e68_1;
        this.f67_1 = this.m66_1.f68_1;
        this.g67_1 = this.m66_1.g68_1;
        var tmp = this;
        var tmp_0;
        if (!(this.m66_1.h68_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.m66_1.k68_1 == null)) {
            var message = "Apollo: 'httpServerUrl' has no effect if 'networkTransport' is set. Configure httpServerUrl on the networkTransport directly.";
            throw IllegalStateException().o(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!(this.m66_1.l68_1 == null)) {
            var message_0 = "Apollo: 'httpEngine' or 'okHttpClient' has no effect if 'networkTransport' is set. Configure httpEngine on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_0));
          }
          // Inline function 'kotlin.check' call
          if (!this.m66_1.x67_1.n1()) {
            var message_1 = "Apollo: 'addHttpInterceptor' has no effect if 'networkTransport' is set. Configure the interceptors on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_1));
          }
          // Inline function 'kotlin.check' call
          if (!(this.m66_1.p68_1 == null)) {
            var message_2 = "Apollo: 'httpExposeErrorBody' has no effect if 'networkTransport' is set. Configure httpExposeErrorBody on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_2));
          }
          tmp_0 = ensureNotNull(this.m66_1.h68_1);
        } else {
          // Inline function 'kotlin.apply' call
          var this_0 = (new (Builder_0())()).i6a(this.m66_1.k68_1);
          if (!(this.m66_1.l68_1 == null)) {
            this_0.j6a(ensureNotNull(this.m66_1.l68_1));
          }
          if (!(this.m66_1.p68_1 == null)) {
            this_0.k6a(ensureNotNull(this.m66_1.p68_1));
          }
          tmp_0 = this_0.l6a(this.m66_1.x67_1).l38();
        }
        tmp.o66_1 = tmp_0;
        var tmp_1 = this;
        var tmp_2;
        if (!(this.m66_1.i68_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.m66_1.m68_1 == null)) {
            var message_3 = "Apollo: 'webSocketServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_3));
          }
          // Inline function 'kotlin.check' call
          if (!(this.m66_1.q68_1 == null)) {
            var message_4 = "Apollo: 'webSocketEngine' or 'okHttpClient' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketEngine on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_4));
          }
          // Inline function 'kotlin.check' call
          if (!(this.m66_1.n68_1 == null)) {
            var message_5 = "Apollo: 'webSocketIdleTimeoutMillis' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketIdleTimeoutMillis on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_5));
          }
          // Inline function 'kotlin.check' call
          if (!(this.m66_1.o68_1 == null)) {
            var message_6 = "Apollo: 'wsProtocolFactory' has no effect if 'subscriptionNetworkTransport' is set. Configure wsProtocolFactory on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_6));
          }
          // Inline function 'kotlin.check' call
          if (!(this.m66_1.r68_1 == null)) {
            var message_7 = "Apollo: 'webSocketReopenWhen' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenWhen on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_7));
          }
          // Inline function 'kotlin.check' call
          if (!(this.m66_1.s68_1 == null)) {
            var message_8 = "Apollo: 'webSocketReopenServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_8));
          }
          tmp_2 = ensureNotNull(this.m66_1.i68_1);
        } else {
          var tmp0_elvis_lhs = this.m66_1.m68_1;
          var url = tmp0_elvis_lhs == null ? this.m66_1.k68_1 : tmp0_elvis_lhs;
          var tmp_3;
          if (url == null) {
            tmp_3 = this.o66_1;
          } else if (!(this.m66_1.q68_1 == null) || !(this.m66_1.o68_1 == null) || !(this.m66_1.r68_1 == null) || !(this.m66_1.s68_1 == null)) {
            // Inline function 'kotlin.apply' call
            var this_1 = (new (Builder_2())()).f69(url);
            if (!(this.m66_1.q68_1 == null)) {
              this_1.c6b(ensureNotNull(this.m66_1.q68_1));
            }
            if (!(this.m66_1.n68_1 == null)) {
              this_1.d6b(ensureNotNull(this.m66_1.n68_1));
            }
            if (!(this.m66_1.o68_1 == null)) {
              this_1.e6b(ensureNotNull(this.m66_1.o68_1));
            }
            if (!(this.m66_1.r68_1 == null)) {
              this_1.f6b(this.m66_1.r68_1);
            }
            if (!(this.m66_1.s68_1 == null)) {
              this_1.g6b(this.m66_1.s68_1);
            }
            tmp_3 = this_1.l38();
          } else {
            // Inline function 'kotlin.apply' call
            var this_2 = (new (Builder_1())()).i6a(url);
            if (!(this.m66_1.n68_1 == null)) {
              Companion_getInstance_0();
              // Inline function 'kotlin.time.Companion.milliseconds' call
              var this_3 = ensureNotNull(this.m66_1.n68_1);
              var tmp$ret$26 = toDuration(this_3, DurationUnit_MILLISECONDS_getInstance());
              this_2.u6a(tmp$ret$26);
            }
            tmp_3 = this_2.l38();
          }
          tmp_2 = tmp_3;
        }
        tmp_1.p66_1 = tmp_2;
        var tmp1_elvis_lhs = this.m66_1.j68_1;
        var dispatcher = tmp1_elvis_lhs == null ? get_defaultDispatcher() : tmp1_elvis_lhs;
        this.n66_1 = new (ConcurrencyInfo())(dispatcher, CoroutineScope_0(dispatcher));
        this.h67_1 = new (NetworkInterceptor())(this.o66_1, this.p66_1);
      }
      h6b(query) {
        return ApolloCall().k66(this, query);
      }
      i6b(mutation) {
        return ApolloCall().k66(this, mutation);
      }
      l6() {
        cancel(this.n66_1.a6a_1);
        this.o66_1.xz();
        this.p66_1.xz();
      }
      i67(apolloRequest, throwing) {
        var flow = channelFlow(ApolloClient$executeAsFlowInternal$slambda_0(this, apolloRequest, throwing));
        return buffer(flow, 2147483647);
      }
      q67(apolloRequest, throwing) {
        var apolloClient = this;
        // Inline function 'kotlin.apply' call
        var this_0 = apolloRequest.h45();
        this_0.c44(this.n66_1.u45(this.r66_1).u45(apolloClient.y66_1).u45(this_0.m43_1));
        var tmp0_elvis_lhs = this_0.o43_1;
        this_0.f44(tmp0_elvis_lhs == null ? apolloClient.a67_1 : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this_0.r43_1;
        this_0.i44(tmp1_elvis_lhs == null ? apolloClient.c67_1 : tmp1_elvis_lhs);
        var tmp2_elvis_lhs = this_0.s43_1;
        this_0.j44(tmp2_elvis_lhs == null ? apolloClient.d67_1 : tmp2_elvis_lhs);
        var tmp3_elvis_lhs = this_0.q43_1;
        this_0.k44(tmp3_elvis_lhs == null ? apolloClient.e67_1 : tmp3_elvis_lhs);
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_1 = ArrayList().p2();
        if (!(this_0.v43_1 === true)) {
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs_0 = apolloClient.b67_1;
          var tmp$ret$6 = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
          this_1.u2(tmp$ret$6);
        }
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs_1 = this_0.p43_1;
        var tmp$ret$7 = tmp0_elvis_lhs_1 == null ? emptyList() : tmp0_elvis_lhs_1;
        this_1.u2(tmp$ret$7);
        var headers = this_1.f8();
        this_0.g44(headers);
        var tmp4_elvis_lhs = this_0.t43_1;
        var canBeBatched = tmp4_elvis_lhs == null ? apolloClient.f67_1 : tmp4_elvis_lhs;
        if (!(canBeBatched == null)) {
          this_0.h44('X-APOLLO-CAN-BE-BATCHED', canBeBatched.toString());
        }
        var tmp5_elvis_lhs = this_0.w43_1;
        var tmp;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = apolloClient.u66_1;
          tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver(apolloRequest);
        } else {
          tmp = tmp5_elvis_lhs;
        }
        this_0.n44(tmp);
        var tmp7_elvis_lhs = this_0.x43_1;
        this_0.o44(tmp7_elvis_lhs == null ? apolloClient.w66_1 : tmp7_elvis_lhs);
        var tmp8_elvis_lhs = this_0.u43_1;
        this_0.m44(tmp8_elvis_lhs == null ? apolloClient.g67_1 : tmp8_elvis_lhs);
        this_0.p44(apolloClient.x66_1);
        var tmp9_elvis_lhs = this_0.n43_1;
        this_0.e44(tmp9_elvis_lhs == null ? apolloClient.z66_1 : tmp9_elvis_lhs);
        var request = this_0.l38();
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_2 = ArrayList().p2();
        this_2.u2(this.m66_1.s67_1);
        if (!(this.s66_1 == null)) {
          this_2.i2(this.s66_1);
        }
        this_2.u2(this.m66_1.t67_1);
        if (!(this.t66_1 == null)) {
          this_2.i2(this.t66_1);
        }
        this_2.u2(this.m66_1.u67_1);
        var tmp0_elvis_lhs_2 = this.v66_1;
        this_2.i2(tmp0_elvis_lhs_2 == null ? RetryOnErrorInterceptor() : tmp0_elvis_lhs_2);
        this_2.u2(this.m66_1.v67_1);
        this_2.i2(this.h67_1);
        var allInterceptors = this_2.f8();
        // Inline function 'kotlin.let' call
        var it = (new (DefaultInterceptorChain())(allInterceptors, 0)).l6b(request);
        var tmp_0;
        if (throwing) {
          tmp_0 = onEach(it, ApolloClient$apolloResponses$slambda_0());
        } else {
          tmp_0 = it;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'ApolloClient');
    ApolloClientClass = $;
  }
  return ApolloClientClass;
}
//region block: exports
export {
  Builder_3 as Builder3lcn00uc5gcy3,
};
//endregion

//# sourceMappingURL=ApolloClient.mjs.map
